import script from "./SportSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SportSection.vue?vue&type=script&setup=true&lang=js"

import "./SportSection.vue?vue&type=style&index=0&id=4db2b104&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db2b104"]])

export default __exports__